import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionLaboratories: IInstitutionLaboratoriesLoadActionCreator = () => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD
        }
    },
    LoadInstitutionLaboratoryById: IInstitutionLaboratoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID,
            id
        }
    },
    LoadInstitutionLaboratoryByLaboratoryId: IInstitutionLaboratoryLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadInstitutionLaboratoryByInstitutionId: IInstitutionLaboratoryLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadSuccess: IInstitutionLaboratoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionLaboratoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionLaboratory: IInstitutionLaboratorySaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionLaboratorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionLaboratorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionLaboratory: IInstitutionLaboratoryCreateActionCreator = (laboratoryId, institutionId) => {

        return {
            type: ACTION_INSTITUTIONLABORATORY_CREATE,
            laboratoryId,
            institutionId
        }
    },
    CreateSuccess: IInstitutionLaboratoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionLaboratoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteInstitutionLaboratory: IInstitutionLaboratoryDeleteActionCreator = (id) => {

        return {
            type: ACTION_INSTITUTIONLABORATORY_DELETE,
            id
        }
    },
    DeleteSuccess: IInstitutionLaboratoryDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_DELETE_SUCCESS,
        }
    },
    DeleteFailure: IInstitutionLaboratoryDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_DELETE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionLaboratory: IInstitutionLaboratoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionLaboratoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionLaboratoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionLaboratoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionLaboratoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONLABORATORY_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONLABORATORY_LOAD = "ACTION_INSTITUTIONLABORATORY_LOAD",
    ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID = "ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID",
    ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID = "ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID",
    ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONLABORATORY_LOAD_SUCCESS = "ACTION_INSTITUTIONLABORATORY_LOAD_SUCCESS",
    ACTION_INSTITUTIONLABORATORY_LOAD_FAILURE = "ACTION_INSTITUTIONLABORATORY_LOAD_FAILURE",

    ACTION_INSTITUTIONLABORATORY_SAVE = "ACTION_INSTITUTIONLABORATORY_SAVE",
    ACTION_INSTITUTIONLABORATORY_SAVE_SUCCESS = "ACTION_INSTITUTIONLABORATORY_SAVE_SUCCESS",
    ACTION_INSTITUTIONLABORATORY_SAVE_FAILURE = "ACTION_INSTITUTIONLABORATORY_SAVE_FAILURE",

    ACTION_INSTITUTIONLABORATORY_CREATE = "ACTION_INSTITUTIONLABORATORY_CREATE",
    ACTION_INSTITUTIONLABORATORY_CREATE_SUCCESS = "ACTION_INSTITUTIONLABORATORY_CREATE_SUCCESS",
    ACTION_INSTITUTIONLABORATORY_CREATE_FAILURE = "ACTION_INSTITUTIONLABORATORY_CREATE_FAILURE",

    ACTION_INSTITUTIONLABORATORY_DELETE = "ACTION_INSTITUTIONLABORATORY_DELETE",
    ACTION_INSTITUTIONLABORATORY_DELETE_SUCCESS = "ACTION_INSTITUTIONLABORATORY_DELETE_SUCCESS",
    ACTION_INSTITUTIONLABORATORY_DELETE_FAILURE = "ACTION_INSTITUTIONLABORATORY_DELETE_FAILURE",

    ACTION_INSTITUTIONLABORATORY_VALIDATE = "ACTION_INSTITUTIONLABORATORY_VALIDATE",
    ACTION_INSTITUTIONLABORATORY_VALIDATE_SUCCESS = "ACTION_INSTITUTIONLABORATORY_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONLABORATORY_VALIDATE_FAILURE = "ACTION_INSTITUTIONLABORATORY_VALIDATE_FAILURE",

    ACTION_INSTITUTIONLABORATORY_CLEAR = "ACTION_INSTITUTIONLABORATORY_CLEAR",

    ACTION_INSTITUTIONLABORATORY_FILTER = "ACTION_INSTITUTIONLABORATORY_FILTER";

export interface IInstitutionLaboratoriesLoadAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD";
}

export interface IInstitutionLaboratoriesLoadActionCreator {
    (): IInstitutionLaboratoriesLoadAction;
}

export interface IInstitutionLaboratoryLoadSuccessAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD_SUCCESS";
    formData: Dtos.InstitutionLaboratory | Dtos.InstitutionLaboratory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionLaboratoryLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionLaboratory | Dtos.InstitutionLaboratory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionLaboratoryLoadSuccessAction;
}

export interface IInstitutionLaboratoryLoadFailureAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionLaboratoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionLaboratoryLoadFailureAction;
}

export interface IInstitutionLaboratoryLoadByIdAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionLaboratoryLoadByIdActionCreator {
    (id: number): IInstitutionLaboratoryLoadByIdAction;
}

export interface IInstitutionLaboratoryLoadByLaboratoryIdAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface IInstitutionLaboratoryLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): IInstitutionLaboratoryLoadByLaboratoryIdAction;
}

export interface IInstitutionLaboratoryLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONLABORATORY_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionLaboratoryLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionLaboratoryLoadByInstitutionIdAction;
}

export interface IInstitutionLaboratorySaveAction {
    type: "ACTION_INSTITUTIONLABORATORY_SAVE";
    formData: Dtos.InstitutionLaboratory;

}

export interface IInstitutionLaboratorySaveActionCreator {
    (
        formData: Dtos.InstitutionLaboratory
    ): IInstitutionLaboratorySaveAction;
}

export interface IInstitutionLaboratorySaveSuccessAction {
    type: "ACTION_INSTITUTIONLABORATORY_SAVE_SUCCESS";
    formData: Dtos.InstitutionLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionLaboratorySaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionLaboratorySaveSuccessAction;
}

export interface IInstitutionLaboratorySaveFailureAction {
    type: "ACTION_INSTITUTIONLABORATORY_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionLaboratorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionLaboratorySaveFailureAction;
}

export interface IInstitutionLaboratoryCreateAction {
    type: "ACTION_INSTITUTIONLABORATORY_CREATE";
    laboratoryId: number | null;
    institutionId: number | null;
}

export interface IInstitutionLaboratoryCreateActionCreator {
    (laboratoryId: number | null, institutionId: number | null): IInstitutionLaboratoryCreateAction
}

export interface IInstitutionLaboratoryCreateSuccessAction {
    type: "ACTION_INSTITUTIONLABORATORY_CREATE_SUCCESS";
    formData: Dtos.InstitutionLaboratory;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IInstitutionLaboratoryCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionLaboratory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionLaboratoryCreateSuccessAction;
}

export interface IInstitutionLaboratoryCreateFailureAction {
    type: "ACTION_INSTITUTIONLABORATORY_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionLaboratoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionLaboratoryCreateFailureAction;
}

export interface IInstitutionLaboratoryDeleteAction {
    type: "ACTION_INSTITUTIONLABORATORY_DELETE";
    id: number;
}

export interface IInstitutionLaboratoryDeleteActionCreator {
    (id: number): IInstitutionLaboratoryDeleteAction
}

export interface IInstitutionLaboratoryDeleteSuccessAction {
    type: "ACTION_INSTITUTIONLABORATORY_DELETE_SUCCESS";
}

export interface IInstitutionLaboratoryDeleteSuccessActionCreator {
    (): IInstitutionLaboratoryDeleteSuccessAction;
}

export interface IInstitutionLaboratoryDeleteFailureAction {
    type: "ACTION_INSTITUTIONLABORATORY_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionLaboratoryDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionLaboratoryDeleteFailureAction;
}

export interface IInstitutionLaboratoryValidateAction {
    type: "ACTION_INSTITUTIONLABORATORY_VALIDATE";
    formData: Dtos.InstitutionLaboratory;

}

export interface IInstitutionLaboratoryValidateActionCreator {
    (
        formData: Dtos.InstitutionLaboratory
    ): IInstitutionLaboratoryValidateAction;
}

export interface IInstitutionLaboratoryValidateSuccessAction {
    type: "ACTION_INSTITUTIONLABORATORY_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionLaboratoryValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionLaboratoryValidateSuccessAction;
}

export interface IInstitutionLaboratoryValidateFailureAction {
    type: "ACTION_INSTITUTIONLABORATORY_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionLaboratoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionLaboratoryValidateFailureAction;
}

export interface IInstitutionLaboratoryClearAction {
    type: "ACTION_INSTITUTIONLABORATORY_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionLaboratoryClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionLaboratoryClearAction;
}

export interface IInstitutionLaboratoryFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionLaboratoryFilterAction;
}

export interface IInstitutionLaboratoryFilterAction {
    type: "ACTION_INSTITUTIONLABORATORY_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionLaboratoryAction =
    IInstitutionLaboratoriesLoadAction |
    IInstitutionLaboratoryLoadByIdAction |
    IInstitutionLaboratoryLoadByLaboratoryIdAction |
    IInstitutionLaboratoryLoadByInstitutionIdAction |
    IInstitutionLaboratoryLoadFailureAction |
    IInstitutionLaboratoryLoadSuccessAction |
    IInstitutionLaboratorySaveAction |
    IInstitutionLaboratorySaveSuccessAction |
    IInstitutionLaboratorySaveFailureAction |
    IInstitutionLaboratoryCreateAction |
    IInstitutionLaboratoryCreateSuccessAction |
    IInstitutionLaboratoryCreateFailureAction |
    IInstitutionLaboratoryDeleteAction |
    IInstitutionLaboratoryDeleteSuccessAction |
    IInstitutionLaboratoryDeleteFailureAction |
    IInstitutionLaboratoryValidateAction |
    IInstitutionLaboratoryValidateSuccessAction |
    IInstitutionLaboratoryValidateFailureAction |
    IInstitutionLaboratoryClearAction |
    IInstitutionLaboratoryFilterAction;
